import React, { Component } from 'react'
import { Card, Button, Row, Col, Input } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { dataCoberturas } from 'redux/selectors/sPymes'
import NumberFormat from 'react-number-format';

class CompletarCoberturas extends Component {
    constructor(props) {
        super(props)
        const generales = {
            numPersonas: 0,
            sumaAsegurada: 0,
            gastosMedicos: 0,
            gastosSepelio: 0,
            gastosAmbulancia: 0
        }
        this.state = { guardar: false, generales, estadoGenerales: false, cobGenerales: [],cambiaData:'btn btn-primary' }
        console.log('CONSTRUCTOR')
    }
    handleClick = async (datos, i, siguiente) => {
        const { idCobertura } = this.props
        let { guardar, generales } = this.state

        //item = item.find(item => item.codigo === 'roturaDeVidrios')
        console.log('RESPUESTA', idCobertura, generales, '------------------------------------------')
        const res = await this.props.guardarCobertura({ arrayData: [], idCobertura, generales })
        console.log('RESPUESTA', res)

        let ubicaciones = []
        let { cobGenerales } = this.state

        if (res.transaccion) {
            ubicaciones = res.ubicaciones
            generales = res.generales
            //cobGenerales = res.limites
            guardar = true
        } else {
            guardar = this.state.guardar
        }

        this.setState({ guardar, generales, cobGenerales,cambiaData:'btn btn-primary' })

        if (!guardar) window.scroll(0, 0)
    }
    componentDidMount() {
        const { cobGenerales } = this.props
        let generales = cobGenerales.reduce((i, { codigo }) => ({ ...i, [codigo]: 0 }), {})
        this.setState({ cobGenerales, generales })
    }
    handleBack = () => {
        this.props.handleAtras()
    }

    handleGenerales = (valor, codigo, maximo) => {
        valor = parseFloat(valor)
        if (isNaN(valor)) valor = 0
        if (valor >= 0) {
            maximo = parseFloat(maximo)
            if (valor <= maximo) {
                let { generales } = this.state
                generales = { ...generales, [codigo]: valor }
                this.setState({ generales,cambiaData:'btn btn-purple fe-pulse' })
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { cobGenerales } = this.props
        if (cobGenerales !== prevProps.cobGenerales) this.setState({ cobGenerales })

    }

    render() {

        const { generales, cobGenerales,cambiaData } = this.state
        const { titulo, nombreGiro, } = this.props

        return (
            <Col md={8}>
                <div className='row' style={{ background: '#e8eaed', margin: 'auto', padding: 10, marginBottom: 10, }}>
                    <Col sm={6}> <h3 style={{ fontWeight: 700, color: '#b6207f', }}>{titulo}</h3> <div style={{}}> Por favor ingrese los valores que desea asegurar </div> </Col>
                    <Col sm={6} style={{ borderLeft: '2px solid #b3b4b6', }} > <h3 style={{ fontWeight: 700, }}> <center> Giro del negocio: </center> </h3> <div style={{ fontSize: '1.3rem', }}> <center> {nombreGiro} </center> </div>  </Col>
                </div>


                <div className='row card'>
                    <Col md={12} className='card-body' style={{ background: '#fff', }}>
                        <div className='flex' style={{ justifyContent: 'space-between', }}>
                            <label style={{ fontWeight: 700, }}> Coberturas Generales: </label>
                            <label style={{ color: '#909090', }}>Valor Máximo</label>
                        </div>
                        {cobGenerales && cobGenerales.map(({ codigo, descripcion, valor }, i) =>
                            <Row key={'coberGenerales' + i}>
                                <Col xs={6} sm={4} > <p style={{ color: (parseInt(valor) === 0 ? '#989898' : null) }}>{descripcion}</p> </Col>
                                <Col xs={6} sm={5}>
                                    <NumberFormat
                                        className="form-control"
                                        thousandSeparator={','}
                                        decimalSeparator={'.'}
                                        style={{ width: 'inherit', fontSize: 20, textAlign: 'right', background: (parseInt(valor) === 0 ? '#f5f5f5' : null) }}
                                        decimalScale={2}
                                        prefix={''}
                                        onValueChange={(_valor, e) => {

                                            this.handleGenerales(_valor.floatValue, codigo, valor)

                                        }}
                                        disabled={parseInt(valor) === 0}
                                        value={generales[codigo]} 
                                />
                                </Col>
                                <Col sm={3}> <p style={{ textAlign: 'right', color: (parseInt(valor) === 0 ? '#989898' : null) }}>{valor.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</p> </Col>
                            </Row>
                        )}
                    </Col>
                    <div className='flex' style={{ margin: 10, }}  >
                        <Button className="btn btn-detail-gray" onClick={() => this.handleBack()} style={{ margin: "auto" }} >
                            <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"  REGRESAR"}
                        </Button>
                        <Button className={cambiaData}  onClick={() => { /*setValidate(true);*/ this.handleClick([], 0, false) }} style={{ margin: "auto", }} >
                            <i className="fa fa-chevron-circle-right " aria-hidden="true" />{' ACTUALIZAR VALORES'}
                        </Button>
                    </div>
                </div>
                {/*nota.length > 0 &&
                    <div className='row card'>
                        <Col md={12} className='card-body' style={{ background: '#fff', }}>
                            <label style={{ fontWeight: 700, }}> Nota: </label>
                            {nota.map((item, i) => <p key={`notasCober${Math.random()}`} >{item}</p>)}
                        </Col></div>} */}

            </Col >
        )
    }
}
const mapStateToProps = (state, props) => ({
    //coberturas: state.dataPymes.maxCoberturas,
    cobGenerales: state.dataPymes.coberturasGenerales[props.idCobertura],
    data: dataCoberturas(state, props),
    cliCodigoCore: state.datosUsuarios.dataUsuario.cliCodigoCore,
})

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        null
    )(CompletarCoberturas)
);